import { createGlobalObservable, useLocalObservable } from 'mobx-vue-lite'
import {  Subject } from 'rxjs';
import { bufferTime } from 'rxjs/operators';
let queue = new Subject();
const nullKeys = ['prototype','$$typeof', 'undefined',"null"];
queue.pipe(bufferTime(500)).subscribe(async (arr)=>{
	if (!arr.length) return;
	let data = arr.reduce((obj, r)=>{
		let [k,v] =  Object.entries(r)[0];
		if (!obj[k]) obj[ k] = []
		if (!obj[k].includes(v))
			obj[ k] .push( v)
		return obj
	},{})
	//	if (import.meta.env.DEV) await new Promise(r=>setTimeout(r,3000))
	window.app.config.globalProperties.$socket.emit('getDbData', data)
	//if (data.docs)
	//Object.assign(window.ss.value.docs,data,docs)
	/* data.forEach(u => {
		usrs[u._id] = u
	}); */
	
})


window.ss =  (createGlobalObservable(() => {
	return useLocalObservable(() => ({
		users:{},
		docs:{},
		dataLoaded:false,
		connState: '',
		extensionInstalled:false,
		set(k,id,v){
			v.loading=0;
			this[k][id] = v
			console.log('set§§',k, id, v, this[k][id])
		}
	}))
}))();
export const usrsProxy = new Proxy(window.ss.value.users,{
	
});
const dataProxy = {
	users:new Proxy(window.ss.value.users, {
		get(o,k){
			if ( (nullKeys).includes(String(k)) ) return;
			if (!o[k]) {
				queue.next({usr:k})
				return {name:'',_id:k, loading:1}
			}
			return window.ss.value.users[k]
		}	
	}),
	docs:new Proxy(window.ss.value.docs, {
		get(t, k) {
			if ( (nullKeys).includes(String(k)) ) return;
			if (!t[k] && typeof k == 'string') {
				queue.next({docs:k})
				return {folders:[], docs:[],name:'',_id:k, loading:1}
			}
			return t[k]
		}
	}),
}

export default new Proxy(window.ss.value, {
	get(o,k){
		console.log('get',k)
		return dataProxy[k] || o[k]
	}
})